module.exports = {
  buildVersion: "0.1.2",
  buildDate: 1744195868295,
}